module.exports = __webpack_public_path__ + "media/images/mini-star-on-307f5565e81d75843c44fa92cd5c1424.svg";